export default __webpack_public_path__ + "static/media/map.72d2b81c.svg";